import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';

// Gentle blink for the attention states (offline / faulty) — never fully off, so it
// reads as "needs attention" without strobing.
const blink = "x13kz0yu-B";
export const styles = {
  base: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1nejdyq",
    kZKoxP: "x17rw0jw",
    kg3NbH: "x1q4txso",
    kaIpWk: "xoy5co8",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kMv6JI: "xdv2sak",
    kGuDYH: "x1qt5hsa",
    k63SB2: "xomqrzn",
    kb6lSQ: "x1yf5rgg",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  good: {
    kWkggS: "x48i0l6",
    kMwMTN: "x1459q0w",
    kVAM5u: "xa126vr",
    $$css: true
  },
  idle: {
    kWkggS: "xvys5x3",
    kMwMTN: "xdxw5r1",
    kVAM5u: "xaj8nyx",
    $$css: true
  },
  warn: {
    kWkggS: "x1qf8r77",
    kMwMTN: "x155pc8g",
    kVAM5u: "xrg9x96",
    $$css: true
  },
  bad: {
    kWkggS: "x8qqj1s",
    kMwMTN: "x2wi9gy",
    kVAM5u: "x1vgqim1",
    $$css: true
  },
  pulse: {
    kKVMdj: "xcx56e2 x1aquc0h",
    k44tkh: "xmg6eyc",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  dot: {
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    kaIpWk: "xoy5co8",
    k1xSpc: "x1rg5ohu",
    kmuXW: "x2lah0s",
    $$css: true
  },
  dot_good: {
    kWkggS: "xlvhwkj",
    kGVxlE: "xc77w73",
    $$css: true
  },
  dot_idle: {
    kWkggS: "x11bye3y",
    $$css: true
  },
  dot_warn: {
    kWkggS: "x7dh1j1",
    $$css: true
  },
  dot_bad: {
    kWkggS: "x4qlrbh",
    $$css: true
  }
};